import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WatchtowerAreaDetectionRBAC = {
  pageID: '11e26221724c5f6e4a7057ed6df8074b',
  elementID: {
    ViewPage: 'c8eb3333be9436b80b9258a558df09bd',
    CreateArea: '026f5e0a0a780b0839f9e79f7dbe606c',
    EditArea: 'bcd0d39a427a1a1feefff09adb3e3680',
    ToggleStatus: '1a4b97cc2be48dc45b50f8b08f700f83',
  },
} as const

export const useWatchtowerAreaDetectionRBACPage = createUseRBAC(
  WatchtowerAreaDetectionRBAC.elementID,
)

export type UseWatchtowerAreaDetectionRBACPageType = ReturnType<
  typeof useWatchtowerAreaDetectionRBACPage
>
